export default __webpack_public_path__ + "assets/fonts/53a52060ff31a5ade82a2b9516e79d11.woff";